module.exports = __webpack_public_path__ + "static/fonts/Oswald-Medium.4195d819.ttf";